<template>
    <div class="vehicle-view-page share-vehicle page pb-3 pl-2 py-2">
        <div class="text-center mt-3">
            <img alt="" height="35" src="/images/logo/foundri-logo.png">
        </div>
        <div class="link-expired" v-if="linkExpired">
            <div class="w-100">
                <h1 class="display-3">Whoops</h1>
                <p class="lead">Sorry, this link has expired.</p>
            </div>
        </div>
        <template v-else>
            <div class="row">
                <div class="col-sm-12">
                    <div class="page-title-box">
                        <h4 class="page-title" id="page_title">Vehicle Details</h4>
                    </div>
                </div>
            </div>
            <div class="card card-body">
                <div>
                    <div class="d-flex justify-content-between pb-3">
                        <h3 class="card-title font-16 m-0 align-self-center">
                            {{ vehicle.formattedFullVehicleName }}
                        </h3>
                        <div class="d-flex align-items-center">
                            <h3 class="card-title font-16 my-0">

                            </h3>
                        </div>
                    </div>
                    <div class="row inner-container m-0">
                        <div class="col-lg-4 col-12 pb-3 p-0">
                            <div class="pb-lg-5">
                                <div class="py-2">
                                    <label>Price: </label>
                                    <span>{{ vehicle.price | currency }}</span>
                                </div>
                                <div class="py-2">
                                    <label>Mileage: </label>
                                    <span>{{ vehicle.mileage | local_number }}</span>
                                </div>
                                <div class="py-2">
                                    <label>Body: </label>
                                    <span>{{ data_get(vehicle, 'body.name') }}</span>
                                </div>
                                <div class="py-2">
                                    <label>Condition: </label>
                                    <span>{{ data_get(vehicle, 'condition.name') }}</span>
                                </div>
                                <div class="py-2">
                                    <label>Color: </label>
                                    <span>{{ data_get(vehicle, 'color.name') }}</span>
                                </div>
                                <div class="py-2">
                                    <label>Status: </label>
                                    <span>
                                    <i :class="{'text-success': vehicle.status === VehicleStatus.available.value, 'text-warning': vehicle.status === VehicleStatus.underOffer.value, 'text-danger': vehicle.status === VehicleStatus.onHold.value}"
                                       class="mdi mdi-checkbox-blank-circle"/>
                                    {{ vehicleStatusLabel }}
                                </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-12 p-0 images-container">
                            <image-swiper
                                :images="imageUrls"
                            />
                        </div>
                    </div>
                    <div>
                        <div class="row">
                            <div class="col-sm-12 px-2">
                                <div class="form-group">
                                    <label class="col-form-label">Additional Information:</label>
                                    <div>
                                        <div>
                                            <div class="row"
                                                 v-if="vehicle && vehicle.additional_information && vehicle.additional_information.length">
                                                <div class="custom-control custom-checkbox col-md-3 col-12 px-2"
                                                     v-for="item in vehicle.additional_information"
                                                     v-if="item.meta && item.meta.availability === InfoAvailabilities.standard">
                                                <span>
                                                    <i class="mdi mdi-checkbox-marked-circle info-check-icon"/>
                                                    {{ item.name }}
                                                </span>
                                                </div>
                                            </div>
                                            <div class="row external-details mt-3">
                                                <div class="custom-control custom-checkbox col-md-3 col-12 px-2"
                                                     v-for="(external_vehicle_detail, index) in ExternalVehicleDetails"
                                                     v-if="vehicle.detail">
                                                    <div>
                                                    <span class="bold">
                                                        {{ external_vehicle_detail.label }}:&nbsp;
                                                    </span>
                                                        {{ vehicle.detail[index] }}
                                                    </div>
                                                </div>
                                                <div class="custom-control custom-checkbox col-md-3 col-12 px-2">
                                                    <div>
                                                    <span class="bold">
                                                        Maximum Towing:&nbsp;
                                                        {{
                                                            getExternalVehicleMaxTowing(vehicle.additional_information)
                                                            ? getExternalVehicleMaxTowing(vehicle.additional_information)
                                                            : 'N/A'
                                                        }}
                                                    </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 px-2">
                                <div class="form-group">
                                    <label class="col-form-label">Additional Features / Accessories: </label>
                                    <textarea :rows="4"
                                              class="form-control"
                                              readonly
                                              title="additional features"
                                              type="text"
                                              v-model="vehicle.additional_features"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import ImageSwiper from "@/components/custom/ImageSwiper";
import InfoAvailabilities from "@/constants/info-availabilities";
import ExternalVehicleDetails from "@/constants/vehicle/external_vehicle_details";
import vehicle_mixin from "@/mixins/vehicle"
import Vehicle from "@/models/vehicle";
import VehicleStatus from "@/constants/vehicle-statuses";

export default {
    mixins: [
        vehicle_mixin
    ],
    components: {
        ImageSwiper
    },
    data() {
        return {
            InfoAvailabilities,
            ExternalVehicleDetails,
                VehicleStatus,
            }
        },
        computed: {
            vehicle() {
                return new Vehicle(App.custom_data.vehicle)
            },
            imageUrls() {
                return _.map(this.vehicle.images, image => image.url)
            },
            linkExpired() {
                return !!App.custom_data.link_expired
            }
        }
    }
</script>
